import {
  AdminState,
  AdminActionTypes,
  SET_DASHBOARD,
  SET_PAGE,
  SET_ARTICLES,
  SET_ARTICLE,
  SET_AUTHORS,
  SET_CATEGORIES,
  SET_SURVEYS,
  SET_SURVEY,
  SET_METRICS,
  SET_METRIC,
  SET_EXCEPTIONS,
  SET_EXCEPTION,
} from './Types';

const initialState: AdminState = {
  dashboard: {
    articles: {
      count: 0,
      views: [],
    },
    authors: {
      count: 0,
      views: [],
    },
    categories: {
      count: 0,
      views: [],
    },
    errors: {
      count: 0,
    },
    metrics: {
      count: 0,
    },
    surveys: {
      count: 0,
      views: [],
    },
  },
  articles: {
    currentPage: 1,
    list: {
      page: 1,
      pageCount: 1,
      itemCount: 0,
      hasNextPage: false,
      hasPreviousPage: false,
      items: [],
    },
  },
  authors: {
    list: [],
  },
  categories: {
    list: [],
  },
  surveys: {
    currentPage: 1,
    list: {
      page: 1,
      pageCount: 1,
      itemCount: 0,
      hasNextPage: false,
      hasPreviousPage: false,
      items: [],
    },
  },
  metrics: {
    currentPage: 1,
    list: {
      page: 1,
      pageCount: 1,
      itemCount: 0,
      hasNextPage: false,
      hasPreviousPage: false,
      items: [],
    },
  },
  exceptions: {
    currentPage: 1,
    list: {
      page: 1,
      pageCount: 1,
      itemCount: 0,
      hasNextPage: false,
      hasPreviousPage: false,
      items: [],
    },
  },
};

export const adminReducer = (state = initialState, action: AdminActionTypes): AdminState => {
  switch (action.type) {
  case SET_DASHBOARD:
    return {
      ...state,
      dashboard: action.payload,
    };
  case SET_PAGE:
    return {
      ...state,
    };
  case SET_ARTICLES:
    return {
      ...state,
      articles: {
        ...state.articles,
        list: action.payload,
      },
    };
  case SET_ARTICLE:
    return {
      ...state,
      articles: {
        ...state.articles,
        current: action.payload,
      },
    };
  case SET_AUTHORS:
    return {
      ...state,
      authors: {
        ...state.authors,
        list: action.payload,
      },
    };
  case SET_CATEGORIES:
    return {
      ...state,
      categories: {
        ...state.categories,
        list: action.payload,
      },
    };
  case SET_SURVEYS:
    return {
      ...state,
      surveys: {
        ...state.surveys,
        list: action.payload,
      },
    };
  case SET_SURVEY:
    return {
      ...state,
      surveys: {
        ...state.surveys,
        current: action.payload,
      },
    };
  case SET_METRICS:
    return {
      ...state,
      metrics: {
        ...state.metrics,
        list: action.payload,
      },
    };
  case SET_METRIC:
    return {
      ...state,
      metrics: {
        ...state.metrics,
        current: action.payload,
      },
    };
  case SET_EXCEPTIONS:
    return {
      ...state,
      exceptions: {
        ...state.exceptions,
        list: action.payload,
      },
    };
  case SET_EXCEPTION:
    return {
      ...state,
      exceptions: {
        ...state.exceptions,
        current: action.payload,
      },
    };
  default:
    return state;
  }
};
